/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_SoundInputs */

const en_pronunciation_report_sound = /** @type {(inputs: Pronunciation_Report_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How should it sound?`)
};

const es_pronunciation_report_sound = /** @type {(inputs: Pronunciation_Report_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo debería sonar?`)
};

/**
* | output |
* | --- |
* | "How should it sound?" |
*
* @param {Pronunciation_Report_SoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_sound = /** @type {((inputs?: Pronunciation_Report_SoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_SoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_sound(inputs)
	return en_pronunciation_report_sound(inputs)
});